import { render } from "./PostEditModal.vue?vue&type=template&id=60f6de66&scoped=true"
import script from "./PostEditModal.vue?vue&type=script&lang=js"
export * from "./PostEditModal.vue?vue&type=script&lang=js"

import "./PostEditModal.vue?vue&type=style&index=0&id=60f6de66&lang=scss&scoped=true"

import exportComponent from "/home/aloco/alocohawaii.com/moa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60f6de66"]])

export default __exports__